//
//
//
//
//
//

export default {
    name: 'LoadingOverlay',
    props: {
        type: {
            type: String,
            required: true,
            validator: value => ['go', 'no-go'].includes(value)
        }
    },
    computed: {
        typeClass() {
            return this.type === 'go' ? 'loading-go' : 'loading-no-go'
        },
        loadingText() {
            return this.type === 'go' ? '處理中...' : '等待重新掃碼，組件正在初始化中...'
        }
    }
}
